import api from "./api";

const toList = (payload: unknown): string[] => {
  const root = (payload as { data?: unknown } | null | undefined)?.data ?? payload ?? [];
  return Array.isArray(root)
    ? root.filter((item): item is string => typeof item === "string")
    : [];
};

export async function fetchChannelStates(country?: string): Promise<string[]> {
  const res = await api.get("/app/channels/states", { params: { country } });
  return toList(res.data);
}

export async function fetchChannelCities(args: {
  country?: string;
  state?: string;
  q?: string;
  signal?: AbortSignal;
}): Promise<string[]> {
  const { signal, ...params } = args;
  const res = await api.get("/app/channels/cities", { params, signal });
  return toList(res.data);
}
